import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Werkstatt')
    .setChildren([
        MenuEntry.create()
            .setRoute('workshop_order_list')
            .setAdditionalRoutes([
                'workshop_order_create',
                'workshop_order_edit',
            ]),

        MenuEntry.create()
            .setRoute('workshop_current_orders'),
        MenuEntry.create()
            .setRoute('workshop_work_unit_list')
            .setAdditionalRoutes([
                'workshop_work_unit_edit',
            ]),
        MenuEntry.create()
            .setRoute('workshop_work_unit_price_group_list'),
        MenuEntry.create()
            .setRoute('workshop_work_unit_customer'),
        MenuEntry.create()
            .setRoute('workshop_date_config'),
        MenuEntry.create()
            .setRoute('workshop_week_day_config'),
    ]);
